import React, { useReducer, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';

import PeopleReducer, {
    initialState,
    UPDATE_PEOPLE,
} from '../reducers/PeopleReducer';

import PeopleService from '../../api/services/PeopleService';
import debugLogger from '../Utils/debugLogger';

const initialContext = initialState;

const PeopleContext = React.createContext(initialContext);

export function PeopleProvider(props) {
    const [peopleState, dispatch] = useReducer(
        PeopleReducer,
        initialState || {},
    );

const getAllPeopleList = async () => {
        try {
            // PeopleService.getPeopleList now returns an object: { success, status, data, text }
            const res = await PeopleService.getPeopleList();

            if (!res) {
                debugLogger('getAllPeopleList: empty response');
                return [];
            }

            if (res.success) {
                // backend payload may be in different shapes: { peopleList: [...] } or an array
                const payload = res.data || {};
                const peopleList = Array.isArray(payload)
                    ? payload
                    : (payload.peopleList || []);

                dispatch({ type: UPDATE_PEOPLE, data: peopleList });
                return peopleList;
            } else {
                debugLogger('getAllPeopleList: API returned failure', res);
                return [];
            }
        } catch (err) {
            debugLogger('read all people error: ', err);
            return [];
        }

    };

    const value = useMemo(
        () => [
            peopleState,
            {
                getAllPeopleList,
            },
        ],
        [peopleState],
    );

    return (
        <PeopleContext.Provider value={value}>
            {props.children}
        </PeopleContext.Provider>
    );
}
const usePeople = () => useContext(PeopleContext);
export { PeopleContext, usePeople };

PeopleProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};
